<template>
    <CurrentCustomCover v-if="presentation.has_custom_cover_image" />
    <CustomCoverUploader />
</template>

<script>
import CurrentCustomCover from "./partials/CurrentCustomCover.vue";
import CustomCoverUploader from "./partials/CustomCoverUploader.vue";
import { useSubmissionWizardStore } from "@storesSw/SubmissionWizardStore";
import { mapState } from "pinia";

export default {
    components: { CurrentCustomCover, CustomCoverUploader },

    computed: {
        ...mapState(useSubmissionWizardStore, ["presentation"]),
    },
};
</script>
